import { render, staticRenderFns } from "./EmptyPage.vue?vue&type=template&id=0666183f&scoped=true&"
import script from "./EmptyPage.vue?vue&type=script&lang=js&"
export * from "./EmptyPage.vue?vue&type=script&lang=js&"
import style0 from "./EmptyPage.vue?vue&type=style&index=0&id=0666183f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0666183f",
  null
  
)

component.options.__file = "EmptyPage.vue"
export default component.exports